// import mutations from './mutation'
// import DateUtils from '@/mixins/DateStrings.js'
import apiSale from '@/services/API/Sale'
// import axios from 'axios'

const setPaymentAmount = function({ commit }, paymentAmount) {
    commit('setPaymentAmount', paymentAmount)
}

const setPaymentMethod = function({ commit }, id) {
    commit('SET_PAYMENT_METHOD', id)
}

const savePayment = function({ commit }) {
    commit('SAVE_PAYMENT')
    commit('CLEAR_PAYMENT')
    // commit('SET_PAYMENT_METHOD', null)
}

const clearInvoiceSelected = function({ commit }) {
    commit('CLEAR_INVOICES_SELECTED')
}

const clearPayment = function({ commit }) {
    commit('CLEAR_PAYMENT')
}

const setPayment = function({ commit }, paymentPayLoad) {
    commit('SET_PAYMENT', paymentPayLoad)
}
const setInvoice = function({ commit }, invoice) {
    commit('SET_INVOICE', invoice)
}
const setPaymentDetail = function({ commit }, payload) {
    commit('SET_PAYMENT_DETAIL', payload)
}
const setBanks = async function({ commit }) {
    // console.log('estoy en setBanks"')
    let banks = await apiSale.fetchBanks()
    // console.log('banks.data', banks.data)
    commit('SET_BANKS', banks)
}

const setStep = function({ commit }, step) {
    commit('SET_STEP', step)
}

const clearArrayPayments = function({ commit }) {
    commit('CLEAR_ARRAY_PAYMENTS')
}

const setArrayPayments = ({ commit }, arrayPayments) =>
    commit('SET_ARRAY_PAYMENTS', arrayPayments)

const resetSale = function({ commit }) {
    commit('RESET_STATE')
}
export default {
    setPaymentAmount,
    setPaymentMethod,
    savePayment,
    clearInvoiceSelected,
    clearPayment,
    setPayment,
    setInvoice,
    setPaymentDetail,
    setBanks,
    setStep,
    clearArrayPayments,
    setArrayPayments,
    resetSale,
}
